import React from 'react';

export const SvgVolumeDown = props => (
  <svg viewBox="0 0 24 24" fill="none" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5.25 14.005v-4c0-.55.45-1 1-1h3l3.29-3.3c.63-.63 1.71-.18 1.71.71v11.17c0 .89-1.08 1.34-1.71.71l-3.29-3.29h-3c-.55 0-1-.45-1-1zm11-6.03a4.5 4.5 0 012.5 4.03c0 1.77-1.02 3.29-2.5 4.02v-8.05z"
      fill="currentColor"
    />
  </svg>
);
